export default __webpack_public_path__ + "static/media/findurpet.ba606373.jpg";